import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
  CustomAction,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/customactionworkflow`;

interface GetAllowedCustomActionWorkflowQueryPayload {
  fileId: string;
}

interface GetAllowedCustomActionWorkflowQueryResponse extends BaseBackResponse {
  value: CustomAction[];
}

async function getAllowedCustomActionWorkflowQuery({
  fileId,
}: GetAllowedCustomActionWorkflowQueryPayload): Promise<
  GetAllowedCustomActionWorkflowQueryResponse | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

    const response = await apiCall<GetAllowedCustomActionWorkflowQueryResponse>(
      url,
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getAllowedCustomActionWorkflowQuery;
